import Vue from 'vue'
import Router from 'vue-router'

//首页
import HomePage from '@/pages/HomePage'
//澳门极草
import MacaoPage from '@/pages/MacaoPage'
//聯系我們
import ContactUs from '@/pages/ContactUs'
//極草產品
import ProductPage from '@/pages/product/ProductPage'
// 冬蟲夏草純粉片服用建議
import SuggestionTaking from '@/pages/product/SuggestionTaking'
// 產品防偽查詢
import SecurityCheck from '@/pages/product/SecurityCheck'
//極草资讯
import InformationPage from '@/pages/article/Information/InformationPage'
//極草资讯新闻详情
import ArticleDetails from '@/pages/article/Information/ArticleDetails'
import ArticleDetailsD from '@/pages/article/dongChongXiaCao/ArticleDetails'
//冬蟲夏草
import CordycepsSinensis from '@/pages/article/dongChongXiaCao/CordycepsSinensis'
//服務門店
import ServiceStore from '@/pages/ServiceStore'
//咨詢服務門店
import CounsellingStore from '@/pages/CounsellingStore'
//購物車
import ShoppingCart from '@/pages/ShoppingCart'
//登錄
import SignIn from '@/pages/login/SignIn'
//註冊
import SignUp from '@/pages/login/SignUp'
//忘記密碼
import ForgetPassword from '@/pages/login/ForgetPassword'
//消費者告知書
import ConsumerNotification from '@/pages/ConsumerNotification'

/***********個人中心 訂單中心 充值中心 帳戶設置***********/
//個人中心
import PersonCenter from '@/pages/personalPage/PersonCenter'
//我的訂單
import MyOrder from '@/pages/personalPage/orderCenter/MyOrder'
// 訂單详情
import OrderDetails from '@/pages/personalPage/orderCenter/OrderDetails'
//我的收藏
import MyCollection from '@/pages/personalPage/orderCenter/MyCollection'
//我的評論
import MyComment from '@/pages/personalPage/orderCenter/MyComment'
//跟蹤包裹
import MyPackage from '@/pages/personalPage/orderCenter/MyPackage'
//查看物流详情
import LogisticsDetails from '@/pages/personalPage/orderCenter/LogisticsDetails'
//賬戶充值
import AccountRecharge from '@/pages/personalPage/assetCenterPage/AccountRecharge'
// 充值明細
import RechargeDetailed from '@/pages/personalPage/assetCenterPage/RechargeDetailed'
// 賬戶明細
import AccountDetailed from '@/pages/personalPage/assetCenterPage/AccountDetailed'
// 積分明細
import IntegralDetailed from '@/pages/personalPage/assetCenterPage/IntegralDetailed'
// 優惠券
import Coupons from '@/pages/personalPage/assetCenterPage/Coupons'
// 實名認證
import RealName from '@/pages/personalPage/accountSettingPage/RealName'
// 帳戶安全
import AccountSecurity from '@/pages/personalPage/accountSettingPage/AccountSecurity'
// 收貨地址
import ReceivingAddress from '@/pages/personalPage/accountSettingPage/ReceivingAddress'

/***********订单商品*************/
// 商品详情
import ShopDetails from '@/pages/detailsPage/ShopDetails'
// 去結算
import SettlementShop from '@/pages/detailsPage/SettlementShop'
// 商城地址修改
import ShopAddress from '@/pages/detailsPage/ShopAddress'
// 协议
import Agreement from '@/pages/clause/Agreement'
// 訂單支付
import OrderPayment from '@/pages/detailsPage/OrderPayment'
// 訂單支付二维码界面
import OrderPaymentQRcodePage from '@/pages/detailsPage/QRcodePage'
// 支付成功
import PaymentSuccess from '@/pages/detailsPage/PaymentSuccess'

/**************購物指南******************/
/*// 支付安全
import SecurityPayment from '@/pages/shoppingGuide/SecurityPayment'
// 配送方式
import DistributionMode from '@/pages/shoppingGuide/DistributionMode'*/
import ShoppingSafety from '@/pages/shoppingGuide/ShoppingSafety'

/**************首页链接******************/
//寸草知我心
import IntroduceOne from '@/pages/advertisement/IntroduceOne'
//虫草怎么吃
import IntroduceThree from '@/pages/advertisement/IntroduceThree'
//冬虫夏草的功效与作用
import IntroduceFour from '@/pages/advertisement/IntroduceFour'
//澳門極草产品
import IntroduceTwo from '@/pages/advertisement/IntroduceTwo'




Vue.use(Router);

export default new Router({
  // history:true,
  // hashbang:false,
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: HomePage
    },
    {
      path: '/macaoPage',
      name: 'MacaoPage',
      component: MacaoPage
    },
    {
      path: '/contactUs',
      name: 'ContactUs',
      component: ContactUs
    },
    {
      path: '/productPage',
      name: 'ProductPage',
      component: ProductPage
    },
    {
      path: '/suggestionTaking',
      name: 'SuggestionTaking',
      component: SuggestionTaking
    },
    {
      path: '/securityCheck',
      name: 'SecurityCheck',
      component: SecurityCheck
    },
    {
      path: '/informationPage',
      name: 'InformationPage',
      component: InformationPage
    },
    {
      path: '/articleDetails',
      name: 'ArticleDetails',
      component: ArticleDetails
    },
    {
      path: '/articleDetails',
      name: 'ArticleDetailsD',
      component: ArticleDetailsD
    },
    {
      path: '/cordycepsSinensis',
      name: 'CordycepsSinensis',
      component: CordycepsSinensis
    },
    {
      path: '/serviceStore',
      name: 'ServiceStore',
      component: ServiceStore
    },
    {
      path: '/counsellingStore',
      name: 'CounsellingStore',
      component: CounsellingStore
    },
    {
      path: '/shoppingCart',
      name: 'ShoppingCart',
      component: ShoppingCart
    },
    {
      path: '/signIn',
      name: 'SignIn',
      component: SignIn
    },
    {
      path: '/signUp',
      name: 'SignUp',
      component: SignUp
    },
    {
      path: '/forgetPassword',
      name: 'ForgetPassword',
      component: ForgetPassword
    },
    {
      path: '/consumerNotification',
      name: 'ConsumerNotification',
      component: ConsumerNotification
    },
    {
      path: '/personCenter',
      name: 'PersonCenter',
      component: PersonCenter
    },
    {
      path: '/myOrder',
      name: 'MyOrder',
      component: MyOrder
    },
    {
      path: '/OrderDetails',
      name: 'OrderDetails',
      component: OrderDetails
    },
    {
      path: '/myCollection',
      name: 'MyCollection',
      component: MyCollection
    },
    {
      path: '/myComment',
      name: 'MyComment',
      component: MyComment
    },
    {
      path: '/myPackage',
      name: 'MyPackage',
      component: MyPackage
    },
    {
      path: '/logisticsDetails',
      name: 'LogisticsDetails',
      component: LogisticsDetails
    },
    {
      path: '/accountRecharge',
      name: 'AccountRecharge',
      component: AccountRecharge
    },
    {
      path: '/rechargeDetailed',
      name: 'RechargeDetailed',
      component: RechargeDetailed
    },
    {
      path: '/accountDetailed',
      name: 'AccountDetailed',
      component: AccountDetailed
    },
    {
      path: '/integralDetailed',
      name: 'IntegralDetailed',
      component: IntegralDetailed
    },
    {
      path: '/coupons',
      name: 'Coupons',
      component: Coupons
    },
    {
      path: '/realName',
      name: 'RealName',
      component: RealName
    },
    {
      path: '/accountSecurity',
      name: 'AccountSecurity',
      component: AccountSecurity
    },
    {
      path: '/receivingAddress',
      name: 'ReceivingAddress',
      component: ReceivingAddress
    },
    {
      path: '/shopDetails',
      name: 'ShopDetails',
      component: ShopDetails
    },
    {
      path: '/settlementShop',
      name: 'SettlementShop',
      component: SettlementShop
    },
    {
      path: '/agreement',
      name: 'Agreement',
      component: Agreement
    },
    {
      path: '/shopAddress',
      name: 'ShopAddress',
      component: ShopAddress
    },
    {
      path: '/orderPayment',
      name: 'OrderPayment',
      component: OrderPayment
    },
    {
        path: '/orderPaymentQRcodePage',
        name: 'OrderPaymentQRcodePage',
        component: OrderPaymentQRcodePage
    },
    {
      path: '/paymentSuccess',
      name: 'PaymentSuccess',
      component: PaymentSuccess
    },
/*    {
      path: '/securityPayment',
      name: 'SecurityPayment',
      component: SecurityPayment
    },*/
   /* {
      path: '/distributionMode',
      name: 'DistributionMode',
      component: DistributionMode
    },*/
    {
      path: '/shoppingSafety',
      name: 'ShoppingSafety',
      component: ShoppingSafety
    },
    {
      path: '/introduceOne',
      name: 'IntroduceOne',
      component: IntroduceOne
    },
    {
      path: '/introduceThree',
      name :'IntroduceThree',
      component: IntroduceThree
    },
    {
      path: '/introduceFour',
      name :'introduceFour',
      component: IntroduceFour
    },
    {
      path: '/introduceTwo',
      name: 'IntroduceTwo',
      component: IntroduceTwo
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js